//insymaOpenMap.js
var map;
var myFGMarker;
var mymarker;
var markers=[];
var z = 0;
window.addEventListener("load", function(evt) {
    document.querySelectorAll("div[data-id='location-box']").forEach((element, index) => {
        element.setAttribute("data-val", index);
    });

    // Hinzufügen der mouseenter und mouseleave Event-Listener
    document.querySelectorAll("div[data-id='location-box']").forEach((element) => {
        element.addEventListener("mouseenter", function() {
            let index = parseInt(this.getAttribute("data-val"));
            markers[index].openPopup();
        });

        element.addEventListener("mouseleave", function() {
            let index = parseInt(this.getAttribute("data-val"));
            markers[index].closePopup();
        });
    });
});
var insymaMapOSM = {
	_initMap: function(mapoptions){
		map = L.map(mapoptions.id).setView([mapoptions.lat, mapoptions.lng], 15);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
        }).addTo(map);
        
        insymaMapOSM._addMarker("", mapoptions.content, mapoptions.lat, mapoptions.lng, mapoptions.icon);
        insymaMapOSM._setMapForBounds(myFGMarker);
        insymaMapOSM._setMapColorScheme(mapoptions);
    },
	_initMapList: function(mapoptions){
		//console.log(mapoptions)
        myFGMarker = new L.FeatureGroup();
        map = L.map(mapoptions.id).setView([mapoptions.lat, mapoptions.lng], 9);
		L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
        }).addTo(map);
        var bounds = [];
        for (var i=0; i < mapoptions.data.length; i++){
			var obj = mapoptions.data[i];
            if(mapoptions.route == true){
                var route_btn = $("div[data-id='" + mapoptions.elem + "']").find("span[data-map-id='route_btn']");
                route_btn.eq(i).attr("data-lat", obj.lat);
                route_btn.eq(i).attr("data-lng", obj.lng)
            }
            insymaMapOSM._addMarker(obj.name, obj.addr, obj.lat, obj.lng, mapoptions.icon);
		}
        insymaMapOSM._setMapForBounds(myFGMarker);
        insymaMapOSM._setMapColorScheme(mapoptions);
    },
	_addMarker: function(aName, aAddr,  aLat, aLng, aImg){
		var myIcon = L.icon({
            iconAnchor: [10, 30],
            iconUrl: aImg,
            popupAnchor: [0, 15],
             /*,
            iconSize: [38, 95],
            iconAnchor: [22, 94],
            
            shadowUrl: '',
            shadowSize: [68, 95],
            shadowAnchor: [22, 94]*/
        });
        mymarker = myIcon;
        var p = L.marker([parseFloat(aLat),parseFloat(aLng)], {icon: myIcon});
        if(typeof(myFGMarker) != "undefined")
            myFGMarker.addLayer(p);
  		p.title = aName;
  		p.alt = aName;
  		p.bindPopup("<strong>" + aName + "</strong><br />" + aAddr);
        markers.push(p);
  		p.addTo(map);
        p._icon.classList.add("specmarker_" + z)
        z++;
    },
    _setMapForBounds: function(myFGMarker){
        if(typeof(myFGMarker) != "undefined"){
            myFGMarker.addTo(map);
            map.fitBounds(myFGMarker.getBounds());
        }
    },
    _setMapColorScheme: function(mapoptions){
        if(mapoptions.cscheme != "" && mapoptions.cscheme != "normal"){
            var mapFilter = getColors(mapoptions.cscheme);
            L.tileLayer.colorFilter('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
                filter: mapFilter
            }).addTo(map);
        }
    },
    _showRoutePlanner: function(aElem, aType, aLang){
        var conEl = "con_" + aElem;
        var routeEl = $("span[data-id='" + aElem + "']");
        var content = $(".route_form").clone();
        $.fancybox.open({
            src: content,
            type: "inline",
            "touch":false,
            helpers:{
                overlay: {
                    locked: false
                }
            },
            opts:{
                afterShow : function( instance, current ) {
                    $(".fancybox-slide--current").find("#end").val(routeEl.data("val").replace(/\+/g, " "));
                    $(".fancybox-slide--current").find("span[data-id='start-routing']").on("click", function(){
                        if(aType == "outside")
                            window.open("http://maps.google.ch/?daddr=" + routeEl.data("val") +"&saddr=" + $(".fancybox-slide--current").find("#start").val().replace(/ /g, "+"));
                        else{
                            var startloc = $(".fancybox-slide--current").find("#start").val().replace(/ /g, "+");
                            $.fancybox.close();
                            insymaMapOSM._setRoute(routeEl.data("val"), startloc, routeEl, aLang);
                            
                        }
                    });
                }
            }   
        });
    },
    _setRoute: function(aDest, aStart, aElem, aLang){
        var content = "<div id='mapid' style='width: 1000px; height: 800px;'></div>"
        $.fancybox.open({
            src: content,
            type: "html",
            touch: false,
            opts:{
                afterShow : function( instance, current ) {
                    var mymap = L.map('mapid').setView([51.505, -0.09], 5);

                    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?lang=de', {
                        maxZoom: 18,
                        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
                            'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                        id: 'mapbox/streets-v11',
                        tileSize: 512,
                        zoomOffset: -1
                    }).addTo(mymap);
                    var myIcon = L.icon({
                        iconAnchor: [16, 34],
                        iconUrl: "https://www.contentupdate.net/CU_BusinessCompanyStandard/web/CU_BusinessCompanyStandard/img/page/cuimgpath/poispotaktiv120x0.png",
                        popupAnchor: [0, 15],
                    });
                    var startcoord_lat = ""; var startcoord_lng = ""; 
                    if(aStart != ""){
                        var startcoords = insymaContentlist._getData("https://nominatim.openstreetmap.org/search?format=json&polygon=1&addressdetails=1&q=" + aStart)
                        if(typeof(startcoords[0].lat) != "undefined"){
                            startcoord_lat = startcoords[0].lat
                            startcoord_lng = startcoords[0].lon
                        }
                        L.Routing.control({
                            waypoints:   [
                                L.latLng([parseFloat(startcoord_lat), parseFloat(startcoord_lng)]),
                                L.latLng([parseFloat(aElem.data("lat")), parseFloat(aElem.data("lng"))])
                            ],
                            language: aLang,
                            createMarker: function(i, wp, nWps) {
                                if (i === 0 || i === nWps - 1) {
                                  // here change the starting and ending icons
                                  return L.marker(wp.latLng, {
                                    icon: myIcon // here pass the custom marker icon instance
                                  });
                                } else {
                                  // here change all the others
                                  return L.marker(wp.latLng, {
                                    icon: myIcon
                                  });
                                }}
                        }).addTo(mymap);
                    }
                }
            }
        });
    },
    _markerFunction: function(aId){
        console.log(aId)
    }
}
/*
https://github.com/xtk93x/Leaflet.TileLayer.ColorFilter
Filter      Desc                                                    Example                 default
Blur        Applies a Gaussian blur filtering measured in pixels    ['blur:2px']            0px
Brightness  Controls the brightness of tile image                   ['brightness:150%']     100%
Contrast    Changes the color contrast of tiles                     ['contrast:150%']       100%
Grayscale   Changes the color of tiles to a grayscale               ['grayscale:100%']      0%
Hue-Rotate  Applies a hue rotation in degrees on tile colors        ['hue:180deg']          0deg
Opacity     Defines the opacity of the tiles                        ['opacity:60%']         100%
Invert      Invert the tile colors                                  ['invert:100%']         0%
Saturate    Saturates the tile colors                               ['saturate:150%']       100%
Sepia       Converts the tile colors to sepia                       ['sepia:0%']            0%
*/
function getColors(aId)
{
    switch(aId){
        case "normal":
            return false;
        case "night":
            return [
                'grayscale:100%',
                'invert:100%',
            ]
        case "dark":
            return[
                'hue:180deg',
                'invert:100%',
            ]
        case "light":
            return [
                'opacity:47%',
                'saturate:0%'
            ]
    }
}